(() => {
  angular
    .module('kareo.ui.shared.directives.ka-collapsable-ul', [])
    .directive('kaCollapsableUl', kaCollapsableUl);

  function kaCollapsableUl() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      link,
      require: '?^^kaCollapsableUl',
      restrict: 'E',
      scope: {
        isOpen: '=?',
        openSref: '@?',
        title: '@?',
        isnew: '@?',
      },
      template: require('./ka-collapsable-ul.tpl.pug')(),
      transclude: true
    };
  }

  controller.$inject = ['$scope', '$state'];
  function controller($scope, $state) {
    const vm = this;

    vm.isOpen = !!vm.isOpen;

    vm.setIsOpen = setIsOpen;
    vm.toggle = toggle;

    init();

    // -------------------------------------------------------------------

    function init() {
      if (!!vm.openSref) {
        refreshFromState();
        listen();
      }
    }

    function listen() {
      $scope.$on('$stateChangeSuccess', refreshFromState);
    }

    function refreshFromState() {
      // state only ever triggers open, never forces close
      if ($state.includes(vm.openSref)) {
        setIsOpen(true);
      }
    }

    function setIsOpen(isOpen) {
      vm.isOpen = isOpen;
    }

    function toggle() {
      vm.isOpen = !vm.isOpen;
    }
  }

  function link(scope, el, attr, parent) {
    // force parent open when opened
    if (parent instanceof controller) {
      scope.$watch('vm.isOpen', (isOpen) => {
        if (isOpen === true) {
          parent.setIsOpen(true);
        }
      });
    }
  }
})();
